import { render, staticRenderFns } from "./ProtectionStatus.vue?vue&type=template&id=7d6674b0&scoped=true&"
import script from "./ProtectionStatus.vue?vue&type=script&lang=js&"
export * from "./ProtectionStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProtectionStatus.vue?vue&type=style&index=0&id=7d6674b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6674b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
